import React from 'react';
import { useProgress } from '@react-three/drei';
import logo from '/imageAssets/pfizer-logo-color.png';

const LoadingScreen = () => {
  const { progress } = useProgress();

  return (
    <div className="loading-screen">
      <img src={logo} alt="Pfizer Logo" className="logo" />
      {/* <div className="loading-bar">
        <div className="loading-progress" style={{ width: `${progress.toFixed(2)}%` }}></div>
      </div> */}
      <p style={{color: 'black'}}>{progress.toFixed(2)}%</p>
    </div>
  );
};

export default LoadingScreen;